export default __webpack_public_path__ + "static/space-2-d71b5b08537a0e2528f740331cd026a1.jpg";